import { post } from '@/infra/rest';
import { ROUTES } from '../constants/routes';

interface SignedUrlResponse {
  success: boolean;
  message: string;
  data: {
    signed_urls: string[];
  };
}

interface SignedUrlRequest {
  file_names?: string[];
  stale_urls?: string[];
  max_age?: number;
  folder?: string;
  sec_ctx?: string; // Optional context for the request
}

export const getSignedUrl = async ({
  file_names,
  max_age,
  folder,
  stale_urls,
  sec_ctx = 'default', // Default context if not provided
}: SignedUrlRequest): Promise<string[]> => {
  
  const requestConfig = {} as any;
  const pathname = window.location.pathname;
  if (pathname.includes(ROUTES.VENDOR_DETAILS)) {
    requestConfig.url = '/v0/rag/workflows/multi_file_va/upload/signed-url';
    requestConfig.config = {
      headers: {
        token: new URLSearchParams(location.search).get('token') || '',
      },
    };
  } else if (pathname.includes('business-owner-auth')) {
    const tokenMatch = pathname.match(/business-owner-auth\/([^/]+)/);
    requestConfig.url = '/v0/tpra/intake-form-v2/business-owner/files/upload/signed-url';
    requestConfig.isAuthRequired = false;
    requestConfig.config = {
      headers: {
        token: tokenMatch?.[1] || '',
      },
      withCredentials: true,
    };
  } else {
    requestConfig.url = '/v0/files/upload/signed-url';
  }

  const data = await post<SignedUrlRequest, SignedUrlResponse>({
    ...requestConfig,
    data: {
      file_names,
      max_age: max_age || 3600,
      folder,
      stale_urls,
      sec_ctx, // Include context in the request
    },
  });

  return data.data.signed_urls;
};
